import { AimsCommonPopupEditorData, AimsCommonTableHeader } from '@aims/common-components';
import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { AIMS_NUMERIC_TYPES } from 'src/app/components/aims-numeric/aims-numeric.component';
import { QualTasks, QualXQualTasks } from '../../training/trainingCommon';

@Component({
  selector: 'app-new-qual-qual-task-dialog',
  templateUrl: './new-qual-qual-task-dialog.component.html',
  styleUrls: ['./new-qual-qual-task-dialog.component.css']
})
export class NewQualQualTaskDialogComponent implements OnInit {

  AIMS_NUMERIC_TYPES = AIMS_NUMERIC_TYPES;
  public formGroup: any;
  public qthDesc: string;
  newQualTask: QualTasks;
  newQualQualTask: QualXQualTasks;
  qualTaskPuValues: Observable<any>;
  qualDesc: string;
  qualificationTaskLookupColumns: AimsCommonTableHeader[];
  qualTaskId: number = 0;
  workSectionValues: Observable<any>;

  constructor(contentData: AimsCommonPopupEditorData,) {
    this.formGroup = contentData.formGroup;
    this.qthDesc = contentData.contentData.qthDesc;
    this.qualTaskPuValues = contentData.contentData.qualTaskPuValues;
    this.qualDesc = contentData.contentData.qualDesc;
    this.qualificationTaskLookupColumns = contentData.contentData.qualificationTaskLookupColumns;
    this.workSectionValues = contentData.contentData.workSectionValues;

    this.formGroup.addControl('qualTaskId', new FormControl(null));

    this.formGroup.addControl('qtDesc', new FormControl('', [Validators.required, Validators.maxLength(250)]));
    this.formGroup.addControl('intervalInMonths', new FormControl(0, Validators.required));
    this.formGroup.addControl('qualTaskWsOwnerId', new FormControl(null, Validators.required));
    this.formGroup.addControl('hazwoper', new FormControl(false));
  }

  handleQualTaskChange(event) {
    if (event == null) {
      this.qualTaskId = null;
      this.setRequiredValidators();
    }
    else {
      this.qualTaskId = event.qualTaskId;
      this.clearRequiredValidators();
    }
  }

  setRequiredValidators() {
      this.formGroup.controls.qtDesc.setValidators([Validators.required, Validators.maxLength(250)]);
      this.formGroup.controls.qtDesc.updateValueAndValidity();
      this.formGroup.controls.intervalInMonths.setValidators([Validators.required]);
      this.formGroup.controls.intervalInMonths.updateValueAndValidity();
      this.formGroup.controls.qualTaskWsOwnerId.setValidators([Validators.required]);
      this.formGroup.controls.qualTaskWsOwnerId.updateValueAndValidity();
  }

  clearRequiredValidators() {
      this.formGroup.controls.qtDesc.clearValidators();
      this.formGroup.controls.qtDesc.updateValueAndValidity();
      this.formGroup.controls.intervalInMonths.clearValidators();
      this.formGroup.controls.intervalInMonths.updateValueAndValidity();
      this.formGroup.controls.qualTaskWsOwnerId.clearValidators();
      this.formGroup.controls.qualTaskWsOwnerId.updateValueAndValidity();
  }

  ngOnInit(): void {
  }

}
